// extracted by mini-css-extract-plugin
export default {"image":"RZ7vz0"};